<template>
  <vue-loading v-if="loading" :active.sync="loading" :is-full-page="true" loader="dots" color="#70A1F0"></vue-loading>
  <div v-else class="box">
    <div class="row">
      <PriorityList :planned='plannedFiltered' :oldThreshold='oldThreshold' :newThreshold='newThreshold' v-on:update='updateData' />
      <div class="column-right">
        <WorkList :progressSorted='progressSorted' :oldThreshold='oldThreshold' :newThreshold='newThreshold'/>
        <div class="spacer"></div>
      </div>
    </div>
  </div>
</template>

<script>
import HTTP from '@/common/http'
import WorkList from '../components/Work/WorkList'
import PriorityList from '../components/Work/PriorityList'
import { mapGetters } from 'vuex'
import VueLoading from 'vue-loading-overlay'

export default {
  components: {
    WorkList,
    PriorityList,
    VueLoading
  },
  computed: {
    ...mapGetters([
      'settings'
    ]),
    plannedFiltered () {
      let filtered = []
      for (var card of this.planned) {
        if (this.settings.work.filter) {
          if (card.members.includes(this.settings.work.filter)) {
            filtered.push(card)
          }
        } else {
          filtered.push(card)
        }
      }
      return filtered
    },
    progressSorted () {
      let vm = this
      let sorted = []
      for (var member of this.progress) {
        let cards = []
        for (var card of member.cards) {
          if (vm.settings.work[card.platform]) {
            cards.push(card)
          }
        }
        if (cards.length > 0) {
          sorted.push({
            member: member.member,
            cards: cards
          })
        }
      }
      sorted.sort(function (a, b) {
        if (a.member === vm.settings.work.pin) { return -1 }
        if (b.member === vm.settings.work.pin) { return 1 }
        if (a.member < b.member) { return -1 }
        if (b.member < a.member) { return 1 }
      })
      return sorted
    }
  },
  created: function () {
    this.loading = true
    this.getWork()
    this.interval = setInterval(function () {
      this.getWork()
    }.bind(this), 30000)
  },
  destroyed: function () {
    clearInterval(this.interval)
  },
  watch: {
    planned: function () {
      this.loading = false
    }
  },
  data () {
    return {
      planned: [],
      progress: [],
      oldThreshold: 20,
      newThreshold: 1,
      interval: '',
      loading: false
    }
  },
  methods: {
    priority: function (cardId, priority) {
      var data = {
        priority: priority
      }
      HTTP.put(`/cards/priority/${cardId}`, data)
        .then(this.getWork())
        .catch((error) => {
          this.flashMessage.error({
            message: `Failed to get card priority : ${error.message}`
          })
        })
    },
    getWork: function () {
      HTTP.get(`/cards/work`)
        .then((response) => {
          this.planned = response.data['planned']
          this.progress = response.data['progress']
        })
        .catch((error) => {
          this.planned = []
          this.flashMessage.error({
            message: `Failed to get cards : ${error.message}`
          })
        })
    },
    updateData: function (event) {
      this.priority(event.cardId, event.newPriority)
    }
  }
}
</script>
<style scoped src='../assets/stylesheet/Work.css'></style>



// WEBPACK FOOTER //
// src/views/Work.vue